<template>
  <b-tooltip :target="target" :placement="placement">
    <slot></slot>
  </b-tooltip>
</template>

<script>
export default {
  name: 'tooltips-item',
  props: ['target', 'placement']
}
</script>

<style lang="scss">
@import "../../assets/stylesheets/styles";

.tooltip {
  background-color: $light;
  padding: 10px;
  border: 1px solid $secondary;
  border-radius: 10px;
  text-align:left;
  line-height: 22px;
  z-index: 1;
  /*margin-left: 60px;*/
  /*margin-top: 15px;*/
  font-size: 12px;
  @include mq-down(md) {
    top: 14px !important;
    left: 45px !important;
    width: 80%;
  }
  @include mq-up(md) {
    width: 63%;
    max-width: 600px;
    min-height: 77px;
    font-size: 14px;
    padding: 20px 30px;
    border-radius: 20px;
    position: absolute;
    top: -51px !important;
    left: 25px !important;
  }
}

.tooltip:after,.tooltip:before {
    border: solid transparent;
    content:'';
    height:0;
    width:0;
    pointer-events:none;
    position:absolute;
  @include mq-down(md) {
    bottom:100%;
    right :25px;
  }
  @include mq-up(md) {
    right:100%;
    top: 40px;
  }
}

.tooltip:after {
    border-color: rgba(245, 245, 245, 0);
    border-top-width:10px;
    border-bottom-width:10px;
    border-left-width:6px;
    border-right-width:6px;
    margin-left: -6px;
    border-bottom-color:#F5F5F5;
  @include mq-up(md) {
    border-color: rgba(245, 245, 245, 0);
    border-left-width:20px;
    border-right-width:20px;
    margin-top: -10px;
    border-right-color:#F5F5F5;
    margin-right: -1px;
  }
}

.tooltip:before {
    border-color: rgba(204, 204, 204, 0);
    border-top-width:11px;
    border-bottom-width:11px;
    border-left-width:7px;
    border-right-width:7px;
    margin-left: -7px;
    margin-bottom: 1px;
    border-bottom-color:#CCCCCC;
  @include mq-up(md) {
    border-color: rgba(204, 204, 204, 0);
    border-left-width:22px;
    border-right-width:22px;
    margin-top: -11px;
    border-right-color:#CCCCCC;
  }
}

</style>



// WEBPACK FOOTER //
// src/components/tooltip/TooltipsItem.vue